/**
 * ViewModeToggle — the Calendar/List segmented control at the top-right of the
 * picker's filter bar (BON-142). Purely a display switch: both views share the
 * same filtered workshop list and the same selection state.
 */
import { Calendar, List } from 'lucide-react';

import type { PickerViewMode } from './pickerViewMode';

export interface ViewModeToggleProps {
  mode: PickerViewMode;
  onChange: (mode: PickerViewMode) => void;
}

const MODES: { id: PickerViewMode; label: string }[] = [
  { id: 'calendar', label: 'Calendar' },
  { id: 'list', label: 'List' },
];

export function ViewModeToggle({ mode, onChange }: ViewModeToggleProps) {
  return (
    <div
      role="group"
      aria-label="Workshop view"
      className="inline-flex flex-shrink-0 rounded-lg border border-stone-200 p-0.5 dark:border-stone-700"
    >
      {MODES.map((m) => {
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(m.id)}
            className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-semibold transition ${
              active
                ? 'bg-moss-600 text-white'
                : 'text-stone-500 hover:text-stone-700 dark:text-stone-400 dark:hover:text-stone-200'
            }`}
          >
            {m.id === 'calendar' ? <Calendar size={13} /> : <List size={13} />}
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
